import React, { Component } from 'react'
import { withRouter } from 'react-router'

import ExoBanner from './ExoBanner'

class Outstream extends Component {
  constructor(props) {
    super(props)

    this.state = {
      renderable: false,
      rendered: false
    }
  }

  componentDidMount() {
    this.setState({
      renderable: true,
      timeStamp: Math.round(new Date().getTime() + Math.random() * 10000)
    })
  }

  componentDidUpdate() {
    const { renderable, rendered } = this.state

    if (rendered || !renderable || !this.container) {
      return
    }

    this.setState(
      {
        rendered: true
      },
      () => {
        const { tags } = this.props

        const script = document.createElement('script')

        script.src = 'https://a.magsrv.com/video-outstream.js'
        script.async = true
        script.dataset.idzone = '5182272'
        script.dataset.frequency_period = '0'
        script.dataset.close_after = '0'
        script.dataset.branding_enabled = '0'
        if (tags && tags.length > 0) {
          script.dataset.ad_tags = tags.join(',')
        }
        script.dataset.ad_sub = '2'

        this.container.appendChild(script)

        this.addNeverblock()
        this.addLoaderScript()
      }
    )
  }

  addLoaderScript() {
    const script = document.createElement('script')

    const scriptId = 'exo-' + Math.floor(Math.random(1000000))
    script.id = scriptId
    script.text = "(AdProvider = window.AdProvider || []).push({'serve': {}});"

    document.body.appendChild(script)

    document.getElementById(scriptId).remove()
  }

  getLoader() {
    const myEl = { l: null }
    const event = new CustomEvent('gel', { detail: myEl })
    window.document.dispatchEvent(event)
    return myEl.l
  }

  addNeverblock() {
    const { nbHash, timeStamp } = this.state

    const neverblockId = this.props.neverblock
    if (!neverblockId) {
      return
    }

    const width = this.props.width
    const height = this.props.height

    const elem = document.getElementById(`i${timeStamp}`)
    if (elem) {
      const data = {
        type: 'banner',
        width,
        height,
        idzone: neverblockId,
        sub: '1',
        codeId: `i${timeStamp}`
      }
      const loader = this.getLoader()
      if (!loader) {
        return
      }

      Array.from(
        document.querySelectorAll(
          `script[src*='${ExoBanner.NB_URL}/${nbHash}']`
        )
      ).forEach(el => {
        el.remove()
      })

      const nbElem = document.getElementById(data.codeId)
      if (!nbElem) {
        return
      }

      nbElem.innerHTML = ''

      const div = document.createElement('div')
      nbElem.appendChild(div)
      data.container = div

      if (loader) {
        loader.addZone(data)
      }

      loader.serve({
        script_url: `https://${
          ExoBanner.NB_URL
        }/${nbHash}/${new Date().getTime()}`,
        force: true
      })
    }
  }

  render() {
    const { renderable, timeStamp } = this.state
    const { neverblock } = this.props

    if (!renderable) {
      return null
    }

    return (
      <>
        <div
          className="outstream"
          ref={e => {
            this.container = e
          }}
        />
        <div id={`i${timeStamp}`} data-nbid={neverblock} />
      </>
    )
  }
}

export default withRouter(Outstream)
